import { render, staticRenderFns } from "./EditCategoryDialog.vue?vue&type=template&id=e00eb0b4&scoped=true&"
import script from "./EditCategoryDialog.vue?vue&type=script&lang=ts&"
export * from "./EditCategoryDialog.vue?vue&type=script&lang=ts&"
import style0 from "./EditCategoryDialog.vue?vue&type=style&index=0&id=e00eb0b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e00eb0b4",
  null
  
)

export default component.exports